import ApeachartsDemo from "./apexcharts-demo";

export default ApeachartsDemo